var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4106_6107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 22C8 20.8954 8.89543 20 10 20H38C39.1046 20 40 20.8954 40 22V26C40 27.1046 39.1046 28 38 28H10C8.89543 28 8 27.1046 8 26V22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 8.89543 20.8954 8 22 8H26C27.1046 8 28 8.89543 28 10V38C28 39.1046 27.1046 40 26 40H22C20.8954 40 20 39.1046 20 38V10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20C20.8954 20 20 20.8954 20 22V26C20 27.1046 20.8954 28 22 28H26C27.1046 28 28 27.1046 28 26V22C28 20.8954 27.1046 20 26 20H22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34C20 32.8954 20.8954 32 22 32H26C27.1046 32 28 32.8954 28 34V38C28 39.1046 27.1046 40 26 40H22C20.8954 40 20 39.1046 20 38V34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22C32 20.8954 32.8954 20 34 20H38C39.1046 20 40 20.8954 40 22V26C40 27.1046 39.1046 28 38 28H34C32.8954 28 32 27.1046 32 26V22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4106_6107)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#paint0_linear_4106_6107)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 46,
    r: 35,
    fill: "url(#paint1_radial_4106_6107)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: 2.65234,
    width: 54.716,
    height: 81.7202,
    transform: "rotate(-50.4948 -29 2.65234)",
    fill: "url(#paint2_radial_4106_6107)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17.6523,
    width: 44.9128,
    height: 41.979,
    transform: "rotate(-50.4948 13 17.6523)",
    fill: "url(#paint3_radial_4106_6107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4106_6107",
    x1: 0,
    y1: 48,
    x2: 48,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE72F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6114B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4106_6107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42 46) rotate(90) scale(35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B103",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4106_6107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.64198 43.5124) rotate(90) scale(40.8601 27.358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68511",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4106_6107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4564 38.6418) rotate(90) scale(20.9895 22.4564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D904",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProducts);
export default __webpack_public_path__ + "static/media/NewProducts.ab81bd90dbc78f3bf5c2dec5e7e2b397.svg";
export { ForwardRef as ReactComponent };